// extracted by mini-css-extract-plugin
export var aniSpin = "b_d";
export var el = "b_b";
export var main = "b_c";